import React, {
    useState,
    useRef,
    useCallback,
    useEffect,
} from 'react';
import { Table, Input, Button, Form, Dropdown, Menu, Modal, List } from 'antd';
import { useForm } from 'antd/lib/form/Form';
const EditableContext = React.createContext(null);
import './index.less';
import {
    SoilProfileDelete,
    SoilProfileDropDownIcon,
    SoilProfileExpandIcon,
    SoilProfileHistoryIcon,
    SoilProfileMapClose
} from '@/resource/IconComponentSets';
import TableHeaderCell from '../TableHeaderCell';
import {
    IData,
    ISoilProfileData,
    updateData,
    updateLayerDetailPartOfProfileModel,
    updateSelectedSoilAnalysis,
    updateSelectedSoilAnalysisVisible
} from '@/redux/reducer/SoilCreatProfiles';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import {
    RootState
} from '@/redux';
import {
    ISoilProfileLayerSampleModel
} from '@/util/Request/requestType';
import AddModel from '@/page/Soil/soil-analyses/Component/AddModel/AddModel';
import {
    transformDateToAMorPMFormat,
    transformDateToTimeStamp,
    transfromDateToTargetFormat
} from '@/util/commonFunction';
import { soilProfileCheckThicknessRange, soilProfileGetLayersDetail } from '@/util/Request';
import IF from '@/components/IF';
enum SoilProfileDataIndex {
    soilLayer = 'layer',
    soilThickness = 'thickness',
    soilThicknessEstimationMethod = 'method',
    soilAnalysis = 'data'
}

const { confirm } = Modal;

// eslint-disable-next-line max-len
// ^[\-\+]?(0(\.\d{1,8})?|([1-9](\d)?)(\.\d{1,8})?|1[0-7]\d{1}(\.\d{1,8})?|180(([.][0]{1,8})?)),[\-\+]?((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$

const EditTableRow = (props) => {
    const [form] = useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

interface IEditTableProps {
    title: string,
    editTable: any,
    children: any,
    dataIndex: string,
    record: IData,
    handleSave: any,
    handleDelete: any,
    restProps: any[]
}

interface IEstimationMethodObj {
    label: string
    key: number
    onClick: () => void
}

const EditTableCell = ({
    title,
    editTable,
    children,
    dataIndex,
    record,
    handleSave,
    handleDelete,
    ...restProps
}: IEditTableProps) => {
    const inputRef = useRef(null);
    const {
        layer,
        method,
        soilAnalysis,
        layerID,
        startDepth,
        endDepth,
        status
    } = record;
    const [selectedAnalysis, setSelectAnalysis] = useState<ISoilProfileLayerSampleModel>();
    const [anlysisSelectModalVisible, setAnlysisSelectModalVisible] = useState(false);
    const [addAnalysisVisible, setAddAnalysisVisible] = useState(false);
    const [menuVisible, setMenuVisible] = useState(false);
    const [sortSoilAnalysis, setSortSoilAnalysis] = useState<ISoilProfileLayerSampleModel[]>();
    /********************************redux value area*******************************/

    useEffect(() => {
        console.log('soilAnalysis', soilAnalysis);
        if (soilAnalysis?.length > 0) {
            const localSoilAnalysis = [...soilAnalysis];
            const sortIdArr = localSoilAnalysis.sort((preItem, afterItem) => {
                const preId = preItem.sampleId;
                const afterId = afterItem.sampleId;
                if (preId > afterId) {
                    return 1;
                }
                return 0;
            });
            setSortSoilAnalysis(sortIdArr);
        }
    }, [soilAnalysis]);

    const {
        estimationMethods,
        actionType,
        profileid,
        fieldRequiredCheckModel,
        selectPublisher
    } = useSelector((state: RootState) => state.soilprofileCreateData);
    const {
        userInfo
    } = useSelector((state: RootState) => state.soilUser);
    const dispatch = useDispatch();

    const [childrenRef, setChildrenRef] = useState(null);

    // SECTION: request for layer detail
    const fetchLatestLayerDetail = useCallback(async () => {
        try {
            const cacheEstimationMethods = [...estimationMethods];
            const response = await soilProfileGetLayersDetail(profileid);
            const data = response.map((item) => {
                const estimation = cacheEstimationMethods.filter((estimation) => estimation.propertyMeasurementID === item.propMeasurementID);
                return {
                    key: `edit-key-${item.layerId}`,
                    layer: item.layer,
                    rank: item.rank,
                    method: estimation[0],
                    soilAnalysis: item.samples,
                    id: 110,
                    layerID: item.layerId,
                    profileCode: record.profileCode,
                    profileName: record.profileName,
                    status: record.status,
                    startDepth: item.layerStartDepth,
                    endDepth: item.layerEndDepth
                };
            });
            dispatch(updateLayerDetailPartOfProfileModel(data));
        } catch(err) {
            console.log('err:===', err);
        }
    }, []);

    /**********************************function area********************************/
    const handleLayerInputChange = (e) => {
        handleSave({ layer: e.target.value, key: record.key });
    };

    // const handleThicknessInputChange = (e) => {
    //     // add the rule that thickness need to promise the three unit number
    //     const reg =/^[1-9][0-9]{0,2}?$/;
    //     const { value } = e.target;
    //     if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
    //         handleSave({ thickness: value, key: record.key});
    //     }
    // };

    const handleStartDepthInputChange = (e) => {
        // add the rule that thickness need to promise the three unit number
        const reg =/^[0-9][0-9]{0,2}?$/;
        const { value } = e.target;
        console.log('value:====', value);
        if (value.length === 0) {
            return handleSave({ startDepth: 0, key: record.key});
        }
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            handleSave({ startDepth: parseInt(value), key: record.key});
        }
    };

    const handleStartOrEndDepthValidate = async (isStartDepth: boolean) => {
        try {
            if (!layerID) {
                return;
            }
            const response = await soilProfileCheckThicknessRange({
                intProfileID: profileid,
                intLayerID: layerID,
                intStartDepth: startDepth,
                intEndDepth: endDepth
            });
            if (response !== 'True') {
                showStartDepthOrEndDepthWarningAlert(isStartDepth);
                if (isStartDepth) {
                    return handleSave({ startDepth: 0, key: record.key});
                }
                handleSave({ endDepth: 0, key: record.key});
            }
        } catch (err) {
            if (isStartDepth) {
                return handleSave({ startDepth: 0, key: record.key});
            }
            handleSave({ endDepth: 0, key: record.key});
        }
    };

    const handleEndDepthInputChange = (e) => {
        // add the rule that thickness need to promise the three unit number
        const reg =/^[0-9][0-9]{0,2}?$/;
        const { value } = e.target;
        if (value.length === 0) {
            return handleSave({ endDepth: 0, key: record.key});
        }
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            handleSave({ endDepth: parseInt(value), key: record.key});
        }
    };


    //Confirm
    const showConfirm = () => {
        confirm({
            title: 'Warning',
            content: 'The layer should save remote first! You can\'t add it now!',
            onOk() {
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const showStartDepthOrEndDepthWarningAlert = (isStartDepth: boolean) => {
        const message = isStartDepth ? 'start depth is invalidate !!' : 'end depth is invalidate !!';
        confirm({
            title: 'Warning',
            content: message,
            className: 'show-start-depth-end-depth-warning',
            onOk() {
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const handleAddAnalysisCallback = () => {
        fetchLatestLayerDetail();
    };

    const handleConcatSampleDateAndCode = (sample: ISoilProfileLayerSampleModel) => {
        if (!sample) {
            return '';
        }
        const sampleCode = sample.sampleCode;
        const sampleDate = sample.sampleDate;
        const transformDate = transfromDateToTargetFormat(sampleDate);
        return `${sampleCode}${transformDate}`;
    };

    const handleClickAddAnalysis = (record) => {
        if (!record.layerID) {
            return showConfirm();
        }
        setAddAnalysisVisible(true);
    };

    const handleEstimationMethodSelect = (item) => {
        setMenuVisible(false);
        handleSave({ method: item, key: record.key });
    };

    const handleClickTargetSample = (item) => {
        setSelectAnalysis(item);

        setAnlysisSelectModalVisible(false);
        dispatch(updateSelectedSoilAnalysis({
            id: item.sampleId,
            layer: record.layer,
            layerID: item.layerId,
            profileCode: record.profileCode,
            profileName: record.profileName,
            sampleCode: item.sampleCode,
            sampleDate: item.sampleDate,
            status: record.status,
            profileID: profileid,
            userID: userInfo.userId,
            publisherID: selectPublisher.userId
        }));
        dispatch(updateSelectedSoilAnalysisVisible(true));
    };

    const handleShowTargetSample = () => {
        setAnlysisSelectModalVisible(false);
        if (!selectedAnalysis) {
            dispatch(updateSelectedSoilAnalysis({
                id: selectedAnalysis ? selectedAnalysis.sampleId : soilAnalysis[0].sampleId,
                layer: record.layer,
                layerID: selectedAnalysis ? selectedAnalysis.layerId : soilAnalysis[0].layerId,
                profileCode: record.profileCode,
                profileName: record.profileName,
                sampleCode: selectedAnalysis ? selectedAnalysis.sampleCode : soilAnalysis[0].sampleCode,
                sampleDate: selectedAnalysis ? selectedAnalysis.sampleDate : soilAnalysis[0].sampleDate,
                status: record.status,
                profileID: profileid,
                userID: userInfo.userId,
                publisherID: selectPublisher.userId
            }));
        }
        dispatch(updateSelectedSoilAnalysisVisible(true));
    };

    const menuArr = estimationMethods.map((estimation) => {
        return {
            label: estimation.methodName,
            key: estimation.propertyMeasurementID,
            onClick: () => handleEstimationMethodSelect(estimation)
        };
    });

    const calculateComponent = useCallback(() => {
        let childNode;
        switch (dataIndex) {
            case SoilProfileDataIndex.soilLayer:
                childNode = (
                    <Form.Item
                        name={dataIndex}
                        rules={[{
                            required:false,
                        }]}
                    >
                        <div className='soilLayer' style={{ width: `${actionType === 'edit' ? '110px' : '250px'}`}}>
                            <Input
                                status={fieldRequiredCheckModel && !layer ? 'error' : null}
                                ref={inputRef}
                                onChange={handleLayerInputChange}
                                value={layer}
                            />
                        </div>
                    </Form.Item>
                );
                break;
            case SoilProfileDataIndex.soilThickness:
                childNode = (
                    <Form.Item
                        name={dataIndex}
                        rules={[{
                            required: false,
                        }]}
                    >
                        <div className='start-depth-end-depth-container'>
                            <div className='soil-add-super-first' style={{ width: '50px'}}>
                                <Input
                                    status={fieldRequiredCheckModel && !startDepth ? 'error' : null}
                                    className='soil-add-input-first'
                                    ref={inputRef}
                                    onChange={handleStartDepthInputChange}
                                    value={startDepth}
                                    onBlur={() => handleStartOrEndDepthValidate(true)}
                                />
                            </div>
                            <span className='connect-span-mark'></span>
                            <div
                                className={`soil-add-super ${fieldRequiredCheckModel && !endDepth ? 'error-end-depth-style' : 'normal-end-depth-style'}`}
                                style={{ width: `${actionType === 'edit' ? '75px' : '80px'}`}}
                            >
                                <Input
                                    className='soil-add-input'
                                    ref={inputRef}
                                    onChange={handleEndDepthInputChange}
                                    value={endDepth}
                                    onBlur={() => handleStartOrEndDepthValidate(false)}
                                />
                                <span className='soil-unit-span'>cm</span>
                            </div>
                        </div>
                    </Form.Item>
                );
                break;
            case SoilProfileDataIndex.soilThicknessEstimationMethod:
                childNode = (
                    <Form.Item
                        name={dataIndex}
                        rules={[{
                            required: false,
                        }]}
                    >
                        <div className='delete-type-super'>
                            <Dropdown
                                onOpenChange={(visible) => {
                                    setMenuVisible(visible);
                                }}
                                trigger={['click']}
                                overlay={<Menu items={menuArr} />}
                                arrow={false}
                            >
                                <span
                                    className={`
                                    ${fieldRequiredCheckModel && !method ? 'estimation-status-error' : null} delete-dropDown-text`}
                                >
                                    {method ? method.methodName : 'Select'}
                                    {menuVisible ? (
                                        <SoilProfileExpandIcon style={{marginLeft: '10px'}} />
                                    ) : (
                                        <SoilProfileDropDownIcon style={{marginLeft: '10px'}} />
                                    )}
                                </span>
                            </Dropdown>
                            <IF show={status === 'Draft' || !status}>
                                <Button className='soil-delete-button' type='text' onClick={() => handleDelete(record)}>
                                    <SoilProfileDelete />
                                </Button>
                            </IF>
                        </div>
                    </Form.Item>
                );
                break;
            case SoilProfileDataIndex.soilAnalysis:
                childNode = (
                    <Form.Item
                        name={dataIndex}
                        rules={[{
                            required: false,
                        }]}
                    >
                        <div className='analysis-item-div'>
                            {addAnalysisVisible && (
                                <AddModel
                                    visible={addAnalysisVisible}
                                    visibleCallback={(visible) => setAddAnalysisVisible(visible)}
                                    defaultProfileid={profileid}
                                    defaultLayerId={layerID}
                                    editParam={{
                                        sampleStatusID:1,
                                        sampleid:'',
                                        samples:{
                                            propertyValues:[
                                                {
                                                    key: '0',
                                                    unitCode:'',
                                                    propertyName: 'Select Soil Properties',
                                                    propertyValue: ' ',
                                                    methodName: 'Select Estimation Method',
                                                    hasTag:false,
                                                    propMeasurementID:'',
                                                    propertyClass:'TYPE'
                                                }
                                            ]
                                        }
                                    }}
                                    addSuccessCallBack={() => handleAddAnalysisCallback()}
                                />
                            )}
                            {anlysisSelectModalVisible && (
                                <div className='analysis-list-container-div'>
                                    <div className='analysis-selected-header'>
                                        <div className='left-div'>
                                            <SoilProfileHistoryIcon className='icon-style'/>
                                            <span className='header-string'>
                                            Soil Analysis History
                                            </span>
                                        </div>
                                        <button onClick={() => setAnlysisSelectModalVisible(!anlysisSelectModalVisible)}>
                                            <SoilProfileMapClose className='soil-analysis-history-in-soil-profile'/>
                                        </button>
                                    </div>
                                    <div className='analysis-selected-container'>
                                        <List
                                            dataSource={sortSoilAnalysis}
                                            className='analysis-list-style'
                                            renderItem={(item) => {
                                                return (
                                                    <List.Item key={item.sampleId}>
                                                        <div className='location-in-div' onClick={() => handleClickTargetSample(item)}>
                                                            <div className='left-div'>
                                                                <span>{item ? handleConcatSampleDateAndCode(item) : ''}</span>
                                                                <span>{item ? transformDateToAMorPMFormat(item.sampleDate) : ''}</span>
                                                            </div>
                                                            <div className='right-div'>
                                                                <button className='history-view-button'>
                                                                    View
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className='add-analysis-or-view-button' style={{ width: `${actionType === 'edit' ? '250px' : '0px'}` }}>
                                <div>
                                    <button onClick={() => handleShowTargetSample()}>
                                        <span>
                                            {selectedAnalysis ? handleConcatSampleDateAndCode(selectedAnalysis) : soilAnalysis && handleConcatSampleDateAndCode(soilAnalysis[0])}
                                        </span>
                                    </button>
                                    <button onClick={() => handleClickAddAnalysis(record)} className='add-soil-analysis'>
                                        +  Add Soil Analysis
                                    </button>
                                </div>
                                <button onClick={() => setAnlysisSelectModalVisible(!anlysisSelectModalVisible)}>
                                    <SoilProfileHistoryIcon />
                                </button>
                            </div>
                        </div>
                    </Form.Item>
                );
                break;
        }
        return childNode;
    }, [
        dataIndex,
        actionType,
        startDepth,
        endDepth,
        method,
        selectedAnalysis,
        anlysisSelectModalVisible,
        status,
        layer,
        addAnalysisVisible,
        soilAnalysis,
        menuVisible
    ]);

    useEffect(() => {
        const childNode = calculateComponent();
        setChildrenRef(childNode);
    }, [
        dataIndex,
        actionType,
        startDepth,
        endDepth,
        method,
        selectedAnalysis,
        anlysisSelectModalVisible,
        status,
        layer,
        addAnalysisVisible,
        soilAnalysis,
        menuVisible
    ]);

    return (
        <td {...restProps}>{childrenRef}</td>
    );
};

// ================================  EditTable Component =====================================
interface column {
    title: any,
    dataIndex: string,
    width?: string,
    height?: string,
    backgroundColor?: string,
    render?: any,
    filterMode?: 'menu' | 'tree',
    filterIcon?: any,
    sorter?: any,
    align?: 'left' | 'right' | 'center',
    filter?: boolean
}

export default function EditableTable() {
    const [count, setCount] = useState(0);
    const dispatch = useDispatch();

    const dataSource = useSelector((state: RootState) => state.soilprofileCreateData.data);
    const actionType = useSelector((state: RootState) => state.soilprofileCreateData.actionType);

    const components = {
        body: {
            row: EditTableRow,
            cell: EditTableCell
        }
    };


    const handleSave = (row) => {
        if (dataSource.length === 1) {
            const item = dataSource[0];
            const newItem: IData = { ...item, ...row };
            dispatch(updateData([newItem]));
        } else {
            const newDataSource = [...dataSource];
            const index = newDataSource.findIndex((item) => item.key === row.key);
            const item = newDataSource[index];
            newDataSource.splice(index,1, {...item, ...row});
            dispatch(updateData(newDataSource));
        }
    };

    const handleAdd = () => {
        const newCount = count + 1;
        const newData = {
            key: `soil-profile-${newCount}`,
            layer: '',
            rank: 1,
            thickness: '',
            method: null,
            startDepth: 0,
            endDepth: 0
        };
        const newDataSource = [...dataSource];
        newDataSource.push(newData);
        dispatch(updateData(newDataSource));
        setCount(newCount);
    };

    //Confirm
    const showConfirm = () => {
        confirm({
            title: 'Warning',
            className: 'soil-profile-remain-at-least-one',
            content: 'There should be remain at least single item.',
            onOk() {
                console.log('OK');
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const handleDelete = (record) => {
        const index = dataSource.findIndex((item) => item.key === record.key);
        if (dataSource.length === 1) {
            showConfirm();
        } else {
            const newDataSource = [...dataSource];
            newDataSource.splice(index, 1);
            dispatch(updateData(newDataSource));
        }
    };

    const columns: column[] = [
        {
            title: (
                <TableHeaderCell
                    title='Soil Layer'
                    type='sort'
                />),
            dataIndex: SoilProfileDataIndex.soilLayer,
            width: '120px',
            height: '20px',
        },
        {
            title: 'Depth',
            dataIndex: SoilProfileDataIndex.soilThickness,
            width: '180px',
            height: '20px',
        },
        actionType === 'edit' && {
            title: 'Soil Analysis',
            dataIndex: SoilProfileDataIndex.soilAnalysis,
            height: '20px',
        },
        {
            title: 'Thickness Estimation Method',
            dataIndex: SoilProfileDataIndex.soilThicknessEstimationMethod,
            width: '300px',
            height: '20px',
        },
    ];

    const columnsHandled = columns.map((col) => {
        return {
            ...col,
            onCell: (record) => {
                return ({
                    record,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave,
                    handleDelete: handleDelete,
                    key: record.key
                });
            }
        };
    });
    return (
        <div className='add-soil-profile-div'>
            <Table
                components={components}
                rowClassName={() => 'editable-row'}
                dataSource={dataSource}
                columns={columnsHandled}
                pagination={false}
                footer={null}
            />
            <button
                onClick={handleAdd}
                className='add-new-profile-button'
            >
                <span className='add-new-profile-span'>
                       +  Add Soil Layer
                </span>
            </button>
        </div>
    );
}
